export const AuthResponse = {
  '01': 'Declined - Call Issuer',
  '04': 'Declined - Pick Up Card',
  '05': 'Declined - Do Not Honor',
  '10': 'Declined - Partial Approval',
  '12': 'Declined - Invalid Transaction',
  '13': 'Declined - Card Amount Invalid',
  '14': 'Declined - Card Number Invalid',
  '15': 'Declined - No Such Issuer',
  '19': 'Declined - Re-Enter',
  '49': 'Declined - Use alternate card or contact bank',
  '51': 'Declined - Insufficient Funds',
  '54': 'Declined - Card Expired',
  '55': 'Declined - Wrong PIN Entered by Card Holder',
  '57': 'Declined - Service Not Allowed',
  '61': 'Declined - Customer Exceeds Withdrawal Limit',
  '62': 'Declined - Restricted SIC Code',
  '63': 'Declined - Restricted',
  '65': 'Declined - Customer Exceeds Activity Limit',
  '78': 'Declined - No Account',
  '97': 'Declined - CVV MisMatch ',
}

const AuthVisaResponse = {
  '00': 'Cancelled - Approved or Completed Successfully',
  '01': 'Refused - Refer to Card Issuer',
  '03': 'Refused - Invalid Merchant',
  '04': 'Refused - Capture Card / Pick-up',
  '05': 'Refused - Do Not Honor',
  '06': 'Refused - Error',
  '07': 'Refused - Pickup Card. Special Condition',
  '10': 'Cancelled - Partial Approval',
  '12': 'Refused - Invalid Transaction',
  '13': 'Refused - Invalid Amount',
  '14': 'Refused - Invalid Card Number',
  '15': 'Refused - Invalid Issuer',
  '19': 'Refused - Re-Enter Transaction',
  '30': 'Refused - Format Error',
  '41': 'Refused - Lost Card',
  '43': 'Refused - Stolen Card',
  '46': 'Refused - Closed Account', //visa
  '51': 'Refused - Insufficient Funds',
  '54': 'Refused - Card Expired',
  '55': 'Refused - Invalid PIN',
  '57': 'Refused - Transaction Not Permitted To Issuer/Cardholder',
  '58': 'Refused - Transaction Not Permitted To Acquirer/Terminal',
  '59': 'Refused - Suspected Fraud',
  '61': 'Refused - Withdrawal Amount Limit Exceeded',
  '62': 'Refused - Restricted Card',
  '63': 'Refused - Security Violation',
  '65': 'Refused - Withdrawal Count Limit Exceeded',
  '6P': 'Refused - Customer ID verification Failed', //visa
  '70': 'Refused - PIN Data Required', //visa
  '75': 'Refused - Number Of Allowed PIN Tries Exceeded',
  '78': 'Refused - Invalid/Nonexistent Account Specified (General)',
  '80': 'Refused - Credit Issuer Unavailable',
  '82': 'Refused - Negative Online CAM, dCVV, iCVV, CVV, Or CAVV Results Or Offline PIN Authentication Interrupted', //visa
  '85': 'Authorised - Not Declined (Valid for all zero amount transactions)',
  '86': 'Refused - Cannot Verify PIN', //visa
  '91': 'Refused/Error - Authorization Platform Or Issuer System Not Available',
  '92': 'Refused - Unable To Route Transaction',
  '93': 'Refused - Transaction Cannot Be Completed; Violation Of Law',
  '96': 'Refused - System Malfunction',
  '1A': 'Refused - Authentication Required', //visa
  R0: 'Refused - Stop Payment Order', //visa
  R1: 'Refused - Revocation Of Authorisation Order', //visa
  R3: 'Refused - Revocation Of All Authorisation Orders', //visa
  Z1: 'Refused - Offline-declined', //visa
  Z3: 'Refused - Unable To Go Online; Offline-declined', //visa
}

const AuthMasterResponse = {
  '00': 'Cancelled - Approved or Completed Successfully',
  '01': 'Refused - Refer to Card Issuer',
  '03': 'Refused - Invalid Merchant',
  '04': 'Refused - Capture Card / Pick-up',
  '05': 'Refused - Do Not Honor',
  '06': 'Refused - Error',
  '07': 'Refused - Pickup Card. Special Condition',
  '10': 'Cancelled - Partial Approval',
  '12': 'Refused - Invalid Transaction',
  '13': 'Refused - Invalid Amount',
  '14': 'Refused - Invalid Card Number',
  '15': 'Refused - Invalid Issuer',
  '19': 'Refused - Re-Enter Transaction',
  '30': 'Refused - Format Error',
  '41': 'Refused - Lost Card',
  '43': 'Refused - Stolen Card',
  '51': 'Refused - Insufficient Funds',
  '54': 'Refused - Card Expired',
  '55': 'Refused - Invalid PIN',
  '57': 'Refused - Transaction Not Permitted To Issuer/Cardholder',
  '58': 'Refused - Transaction Not Permitted To Acquirer/Terminal',
  '59': 'Refused - Suspected Fraud',
  '61': 'Refused - Withdrawal Amount Limit Exceeded',
  '62': 'Refused - Restricted Card',
  '63': 'Refused - Security Violation',
  '65': 'Refused - Authentication required', //master
  '70': 'Refused - Contact Card Issuer', //master
  '75': 'Refused - Number Of Allowed PIN Tries Exceeded',
  '78': 'Refused - Invalid/Nonexistent Account Specified (General)',
  '80': 'Refused - Credit Issuer Unavailable',
  '85': 'Authorised - Not Declined (Valid for all zero amount transactions)',
  '91': 'Refused/Error - Authorization Platform Or Issuer System Not Available',
  '92': 'Refused - Unable To Route Transaction',
  '93': 'Refused - Transaction Cannot Be Completed; Violation Of Law',
  '96': 'Refused - System Malfunction',
}

export function mapAuthResponseToText(responseCode: string, brand = '') {
  if (brand) brand = brand.toLowerCase()
  const responseMap =
    brand === 'mastercard'
      ? AuthMasterResponse
      : brand === 'visa'
        ? AuthVisaResponse
        : AuthResponse

  return responseMap[responseCode] || ''
}
